import { render, staticRenderFns } from "./SidebarTransverse.vue?vue&type=template&id=34ef4d3e&scoped=true"
import script from "./SidebarTransverse.vue?vue&type=script&lang=js"
export * from "./SidebarTransverse.vue?vue&type=script&lang=js"
import style0 from "./SidebarTransverse.vue?vue&type=style&index=0&id=34ef4d3e&prod&lang=scss&scoped=true"
import style1 from "./SidebarTransverse.vue?vue&type=style&index=1&id=34ef4d3e&prod&scoped=true&lang=css"
import style2 from "./SidebarTransverse.vue?vue&type=style&index=2&id=34ef4d3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ef4d3e",
  null
  
)

export default component.exports